import React from "react";
import { GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useHRCalendar } from "../../hooks/useHRCalendar";
import HRCalendarModule from "../../components/modules/HRCalendar/HRCalendarModule";

const HRCalendarPage = ({ user, userAccess, isHideSideMenu }) => {
  // Initialize the hook once here
  const hrCalendarMethods = useHRCalendar();

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"HR Calendar"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">HR Calendar</h3>
            </div>

            {/* Pass all hook data and methods to the module */}
            <HRCalendarModule
              user={user}
              {...hrCalendarMethods}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={hrCalendarMethods.showMessage}
        message={hrCalendarMethods.message}
        isSuccess={hrCalendarMethods.isSuccess}
      />

      <LoadingSpinner loading={hrCalendarMethods.loading} />
    </>
  );
};

export default HRCalendarPage;